"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Blossom = void 0;
const api_actions_enum_1 = require("./constants/api-actions.enum");
const blossom_messages_factory_1 = require("./messages/blossom-messages.factory");
const fdp_storage_proxy_factory_1 = __importDefault(require("./proxy/fdp-storage.proxy.factory"));
const signer_1 = require("./signer");
const dapp_util_1 = require("./utils/dapp.util");
const wallet_1 = require("./wallet");
/**
 * Interface of the Blossom browser extension
 * This class can be used inside of a web page or service worker script
 */
class Blossom {
    /**
     *
     * @param extensionId The Blossom extension ID
     */
    constructor(extensionId = 'caedjloenbhibmaeffockkiallpngmmd') {
        /**
         * dApp ENS name. If dApp is loaded from an invalid URL, the value will be null.
         */
        this.dappId = (0, dapp_util_1.getDappId)();
        this.messages = (0, blossom_messages_factory_1.createBlossomMessages)(extensionId);
        this.fdpStorage = (0, fdp_storage_proxy_factory_1.default)(this.messages);
        this.signer = new signer_1.Signer(this.messages);
        this.wallet = new wallet_1.Wallet(this.messages);
    }
    /**
     * Test function, to check communication with the extension
     * @param data Any data
     * @returns The same data
     */
    echo(data) {
        return this.messages.sendMessage(api_actions_enum_1.ApiActions.ECHO, data);
    }
    closeConnection() {
        this.messages.closeConnection();
    }
}
exports.Blossom = Blossom;
